import { render, staticRenderFns } from "./aicenter.vue?vue&type=template&id=e58ca6fe&scoped=true&"
import script from "./aicenter.vue?vue&type=script&lang=js&"
export * from "./aicenter.vue?vue&type=script&lang=js&"
import style0 from "./aicenter.vue?vue&type=style&index=0&id=e58ca6fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58ca6fe",
  null
  
)

export default component.exports